/*
 * IconButton
 * @module components
 * @flow
 */

import styled, { css, keyframes } from 'styled-components/macro';
import { palette } from 'styled-theme';
import { switchProp } from 'styled-tools';

// $FlowIssue
import { ReactComponent as IconLoader } from '@/icons/loader.svg';

export type LoaderProps = {
  palette?: string,
  size?: 'small' | 'medium' | 'large',
};

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const styles = css`
  color: ${palette(1)};
  ${switchProp('size', {
    small: css`
      width: 28px;
      height: 28px;
    `,
    medium: css`
      width: 31px;
      height: 31px;
    `,
    large: css`
      width: 40px;
      height: 40px;
    `,
    giant: css`
      width: 80px;
      height: 80px;
    `,
  })};
  transform-origin: center;
  animation: ${rotate} 1.2s linear infinite;
`;

/**
 * Loader React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {('small'|'medium'|'large'|'giant')} [props.size = large] - input size parameter
 * @param {string} [props.palette = 'primary'] - current button palette
 * @example <caption>Simple usage</caption>
 * <Loader />
 * @returns {React.Node<*>} React-component
 */
export const Loader = styled(IconLoader).attrs(() => ({
  testid: 'loader',
}))`
  ${styles};
`;

Loader.defaultProps = {
  palette: 'primary',
  size: 'large',
  testid: 'loader',
};
